import classes from "./ActivityEditor.module.css";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import {
    POLL_TYPE,

} from "../../utils/constants";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {ReactComponent as INFO_ICON} from "../../images/info_icon.svg"

import ActivityEditorConfigurationSectionA from "./ActivityEditorConfigurationSectionA";
import ActivityEditorConfigurationSectionB from "./ActivityEditorConfigurationSectionB";

export default function ActivityEditorConfiguration({draftActivity, setDraftActivity, courseList, userSettings, hasReleased=false}) {
    const {t} = useTranslation();
    const columnLayoutStyle = {width: "100%", display: "flex", flexDirection: "column"};

    return (
        <div className={classes.questionMainContainer} >
            <span className={settingsClasses.cardDescription}>
                {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                    ? t("institution.attendanceDetailsSettingsDescription")
                    : t("institution.pollDetailsSettingsDescription")
                }
            </span>

            {hasReleased &&
                <div style={columnLayoutStyle}>
                    <div className={settingsClasses.settingLabel}>{t("questionBuilder.enabledConfigurations")}</div>
                    <span style={{border: "1px solid #E0E0E0", width: "100%", margin: "5px 0"}}></span>
                </div>
            }


            <ActivityEditorConfigurationSectionA
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                userSettings={userSettings}
                hasReleased={hasReleased}
            />

            {hasReleased &&
                <div style={{...columnLayoutStyle, marginTop: 20}}>
                    <div className={settingsClasses.settingLabel}>{t("questionBuilder.disabledConfigurations")}</div>
                    <span style={{border: "1px solid #E0E0E0", width: "100%", margin: "5px 0"}}></span>
                </div>
            }

            {hasReleased &&
                <div className={classes.disabledNotification} style={{marginBottom: 0}}>
                    <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                    <span>
                        <span className={classes.title} style={{marginRight: 5}}>
                            {t("questionBuilder.editingDisabled")}
                        </span>
                        <span>
                            {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                ? t("questionBuilder.configLockedAttendance")
                                : t("questionBuilder.configLockedPoll")
                            }
                        </span>
                    </span>
                </div>
            }

            <ActivityEditorConfigurationSectionB
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                userSettings={userSettings}
                courseList={courseList}
                hasReleased={hasReleased}
            />

        </div>
    );
}